'use strict';

/**
 * View showing active filter buttons
 *
 * @category   View
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('modules/base/templates/layout/filter-active-filters.hbs');

var ActiveFiltersView = LayoutView.extend({
    template: template,

    tagName: 'ul',

    className: 'active-filters',

    ui: {
        actionClearFilter: '[data-action="clear-filter"]',
    },

    events: {
        'click @ui.actionClearFilter': 'actionClearFilter',
    },

    initialize: function(options) {
        this.components = _.result(this.collection, 'filterComponents');

        this.initializeComponents();

        LayoutView.prototype.initialize.apply(this, arguments);
    },

    initializeComponents: function() {
        this.components = this.getOption('components');

        this.components.forEach(function(section){
            section.forEach(function(component){
                var componentViewOptions = _.extend({}, {
                    name: component.name,
                    displayName: component.displayName,
                    title: component.title,
                    modelAttribute: component.modelAttribute,
                    activeFilters: this.getOption('activeFilter'),
                    options: component.options,
                    collection: this.collection,
                }, component.options);

                component.view = new this.collection.componentViews[component.type](componentViewOptions);
            }.bind(this));
        }.bind(this));
    },

    viewData: {
        activeFilterButtons: function() {
            var activeFilterButtons = [];

            this.components.forEach(function(section){
                section.forEach(function(component){
                    activeFilterButtons.push(component.view.renderListFilterButton());
                }.bind(this));
            }.bind(this));

            return _.compact(activeFilterButtons);
        },
    },

    actionClearFilter: function(event) {
        var activeFilters = this.getOption('activeFilter');
        var filterToRemove = _.camelcase($(event.currentTarget).data('filter-name'));
        var newFilters = activeFilters.replace(new RegExp(_.escape(filterToRemove) + '\/.+?(\/|$)'), '').replace(/\/$/, '');

        this.getOption('stateModel').set('filter', newFilters);
    },
});

module.exports = ActiveFiltersView;